module.exports = __webpack_public_path__ + "static/media/椭1.87bee06e.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_190/images/椭1.png
// module id = 1674
// module chunks = 0